import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { UiCoreModule } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-faelldt-list-view',
  imports: [UiCoreModule],
  templateUrl: './faelldt.list-view.html',
  styleUrls: ['./faelldt.list-view.css'],
})
export class FaelldtListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
